import UploadAvatar from './uploadAvatar';

export default UploadAvatar;
